interface MenuBarIconProps {
    icon: JSX.Element;
    onHover: (toolId: string) => void;
    menuItem: string;
    activeMenuItem: string | null;
}

function MenuBarIcon({ icon, onHover, menuItem, activeMenuItem }: MenuBarIconProps) {
    return (
        <div
            onMouseEnter={() => onHover(menuItem)}
            className={activeMenuItem === menuItem ? "active" : ""}
        >
            {icon}
        </div>
    )
}

export default MenuBarIcon;